// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mic';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 14.625v2.813M9.375.563h-.75a3 3 0 0 0-3 3V9a3 3 0 0 0 3 3h.75a3 3 0 0 0 3-3V3.562a3 3 0 0 0-3-3z' />
    <path d='M3 7.313V9a5.625 5.625 0 0 0 5.625 5.625h.75A5.625 5.625 0 0 0 15 9V7.312' />
  </g>
);

export const viewBox = '0 0 18 18';
